"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MACHINE_ICONS = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconsMaterial = require("@mui/icons-material");
var _colors = require("./colors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/* eslint-disable max-len */

var MACHINE_ICONS = exports.MACHINE_ICONS = {
  idle: function idle(color) {
    return /*#__PURE__*/_react["default"].createElement(_iconsMaterial.PauseCircleOutlineOutlined, {
      sx: {
        fontSize: '2rem',
        color: _colors.MACHINE_IDLE_COLOR
      }
    });
  },
  error: function error(color) {
    return /*#__PURE__*/_react["default"].createElement(_iconsMaterial.CancelOutlined, {
      sx: {
        fontSize: '2rem',
        color: _colors.MACHINE_CRITICAL_COLOR
      }
    });
  },
  maintenance: function maintenance(color) {
    return /*#__PURE__*/_react["default"].createElement(_iconsMaterial.PauseCircleOutlineOutlined, {
      sx: {
        fontSize: '2rem',
        color: _colors.MACHINE_MAINTENANCE_COLOR
      }
    });
  },
  missingLink: function missingLink(color) {
    return /*#__PURE__*/_react["default"].createElement(_iconsMaterial.HelpOutlineOutlined, {
      sx: {
        fontSize: '2rem',
        color: _colors.MACHINE_NO_DATA_COLOR
      }
    });
  },
  running: function running(color) {
    return /*#__PURE__*/_react["default"].createElement(_iconsMaterial.CheckCircleOutlineOutlined, {
      sx: {
        fontSize: '2rem',
        color: _colors.MACHINE_RUNNING_COLOR
      }
    });
  },
  warning: function warning(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "12",
      cy: "12",
      r: "12",
      fill: _colors.MACHINE_WARNING_COLOR
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.3333 6H10.6667V14H13.3333V6ZM13.3333 16.6667C13.3333 17.403 12.7364 18 12 18C11.2636 18 10.6667 17.403 10.6667 16.6667C10.6667 15.9303 11.2636 15.3333 12 15.3333C12.7364 15.3333 13.3333 15.9303 13.3333 16.6667Z",
      fill: "white"
    }));
  },
  sensorCurrent: function sensorCurrent(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: color,
      fillOpacity: "0.1"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.0768 8.22217C20.4535 8.22217 24.0288 11.6298 24.3678 15.9359H27.1109V17.1751H24.337C24.0288 21.4811 20.4535 24.8888 16.0768 24.8888C11.7002 24.8888 8.12492 21.4811 7.8167 17.1751H4.88867V15.9359H7.8167C8.12492 11.6298 11.7002 8.22217 16.0768 8.22217ZM9.45024 16.5555C9.45024 20.211 12.4091 23.216 16.0768 23.216C19.7446 23.216 22.7343 20.242 22.7034 16.5555C22.7034 12.9 19.7446 9.89503 16.0768 9.89503C12.4399 9.89503 9.45024 12.869 9.45024 16.5555ZM12.7481 20.242L15.522 12.838H16.6932L19.4672 20.242H18.1418L17.5254 18.5072H14.659L14.0734 20.242H12.7481ZM16.1076 14.4179L15.0289 17.4849H17.1864L16.1076 14.4179Z",
      fill: color
    }));
  },
  sensorDensity: function sensorDensity(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: color,
      fillOpacity: "0.1"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M27.1109 16.0504C27.1109 14.6789 26.4262 13.4322 25.4302 12.6842C26.4262 11.8738 27.1109 10.6894 27.1109 9.31799C27.1109 6.9492 25.1812 4.95443 22.7536 4.95443C21.3842 4.95443 20.1392 5.64013 19.3923 6.63752C18.583 5.57779 17.4003 4.89209 16.0309 4.89209C14.6615 4.89209 13.4165 5.57779 12.6696 6.57518C11.7981 5.57779 10.6154 4.89209 9.24597 4.89209C6.81833 4.89209 4.88867 6.82453 4.88867 9.25566C4.88867 10.6271 5.57339 11.8738 6.56934 12.6218C5.57339 13.4322 4.88867 14.6166 4.88867 16.0504C4.88867 17.4218 5.57339 18.6685 6.56934 19.4165C5.57339 20.2269 4.88867 21.4113 4.88867 22.7827C4.88867 25.1515 6.81833 27.1463 9.24597 27.1463C10.6154 27.1463 11.8603 26.4606 12.6073 25.4632C13.4165 26.4606 14.5992 27.1463 15.9687 27.1463C17.3381 27.1463 18.583 26.4606 19.33 25.4632C20.1392 26.4606 21.3219 27.1463 22.6914 27.1463C25.0567 27.1463 27.0486 25.2139 27.0486 22.7827C27.0486 21.4113 26.3639 20.1646 25.368 19.4165C26.4262 18.6062 27.1109 17.4218 27.1109 16.0504ZM19.3923 13.3699C19.2055 13.1205 18.9565 12.8712 18.6453 12.6218C18.8943 12.4348 19.1433 12.1855 19.3923 11.8738C19.579 12.1231 19.828 12.3725 20.1392 12.6218C19.828 12.8088 19.579 13.0582 19.3923 13.3699ZM20.1392 19.4165C19.8902 19.6035 19.6412 19.8529 19.3923 20.1646C19.2055 19.9152 18.9565 19.6659 18.6453 19.4165C18.8943 19.2295 19.1433 18.9802 19.3923 18.6685C19.579 18.9802 19.828 19.2295 20.1392 19.4165ZM18.4585 9.25566C18.4585 10.6271 17.3381 11.6868 16.0309 11.6868C14.6615 11.6868 13.6033 10.5647 13.6033 9.25566C13.6033 7.94659 14.6615 6.76219 16.0309 6.76219C17.3381 6.76219 18.4585 7.88425 18.4585 9.25566ZM18.4585 16.0504C18.4585 17.4218 17.3381 18.4815 16.0309 18.4815C14.6615 18.4815 13.6033 17.3594 13.6033 16.0504C13.6033 14.6789 14.7237 13.6192 16.0309 13.6192C17.3381 13.5569 18.4585 14.6789 18.4585 16.0504ZM13.3543 12.6218C13.1053 12.8088 12.8563 13.0582 12.6073 13.3699C12.4206 13.1205 12.1716 12.8712 11.8604 12.6218C12.1093 12.4348 12.3583 12.1855 12.6073 11.8738C12.7941 12.1855 13.043 12.4348 13.3543 12.6218ZM12.6073 18.6685C12.7941 18.9178 13.043 19.1672 13.3543 19.4165C13.1053 19.6035 12.8563 19.8529 12.6073 20.1646C12.4206 19.9152 12.1716 19.6659 11.8604 19.4165C12.1716 19.2295 12.4206 18.9802 12.6073 18.6685ZM13.541 22.7827C13.541 21.4113 14.6615 20.3516 15.9687 20.3516C17.3381 20.3516 18.3963 21.4736 18.3963 22.7827C18.3963 24.1541 17.2758 25.2138 15.9687 25.2138C14.6615 25.2762 13.541 24.1541 13.541 22.7827ZM20.326 22.7827C20.326 21.4113 21.4464 20.3516 22.7536 20.3516C24.123 20.3516 25.1812 21.4736 25.1812 22.7827C25.1812 24.1541 24.0608 25.2138 22.7536 25.2138C21.4464 25.2762 20.326 24.1541 20.326 22.7827ZM22.7536 18.4815C21.3842 18.4815 20.326 17.3594 20.326 16.0504C20.326 14.6789 21.4464 13.6192 22.7536 13.6192C24.123 13.6192 25.1812 14.7413 25.1812 16.0504C25.2435 17.3594 24.123 18.4815 22.7536 18.4815ZM22.7536 11.6868C21.3842 11.6868 20.326 10.5647 20.326 9.25566C20.326 7.94659 21.4464 6.76219 22.7536 6.76219C24.123 6.76219 25.1812 7.88425 25.1812 9.19332C25.1812 10.5024 24.123 11.6868 22.7536 11.6868ZM9.24597 6.76219C9.37047 6.76219 9.49496 6.76219 9.55721 6.82453C10.7399 6.9492 11.6736 8.00892 11.6736 9.25566C11.6736 10.5024 10.7399 11.4998 9.55721 11.6868C9.43271 11.6868 9.37047 11.7491 9.24597 11.7491C7.87653 11.6868 6.75609 10.5647 6.75609 9.25566C6.75609 7.94659 7.87653 6.76219 9.24597 6.76219ZM9.24597 13.5569C9.37047 13.5569 9.49496 13.5569 9.55721 13.6192C10.7399 13.8062 11.6736 14.8036 11.6736 16.0504C11.6736 17.2971 10.7399 18.2945 9.55721 18.4815C9.43271 18.4815 9.37047 18.5438 9.24597 18.5438C7.87653 18.4815 6.75609 17.3594 6.75609 16.0504C6.75609 14.6789 7.87653 13.5569 9.24597 13.5569ZM9.24597 25.2762C7.87653 25.2762 6.81833 24.1541 6.81833 22.8451C6.81833 21.4736 7.93878 20.4139 9.24597 20.4139C9.37047 20.4139 9.49496 20.4139 9.55721 20.4763C10.7399 20.6633 11.6736 21.6607 11.6736 22.9074C11.6736 24.1541 10.7399 25.1515 9.55721 25.3385C9.43271 25.2762 9.30822 25.2762 9.24597 25.2762Z",
      fill: color
    }));
  },
  sensorEnergy: function sensorEnergy(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: color,
      fillOpacity: "0.1"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.0626 24.9135C20.7562 24.9135 24.6607 21.2651 24.9515 16.6217L27.1114 17.0363C26.5714 22.6747 21.8362 27.1109 16.021 27.1109C9.87358 27.1109 4.88916 22.1358 4.88916 15.9998C4.88916 9.8638 9.87358 4.88867 16.021 4.88867C18.3886 4.88867 20.5486 5.59348 22.3346 6.83726L23.4977 5.6764V9.40774H19.7594L20.7147 8.45418C19.344 7.62499 17.7241 7.12748 16.021 7.12748C11.1197 7.12748 7.13215 11.0661 7.13215 15.9998C7.13215 20.9334 11.1197 24.9135 16.0626 24.9135ZM17.9156 14.25H20.9212L13.8334 22.2822L14.4166 17.6924H11.8596L15.4932 10.4546H19.9343L17.9156 14.25ZM13.8559 16.4567H16.0764L15.4484 18.6633L18.5436 15.221L16.0764 15.1327L18.0053 11.6462H16.3007L13.8559 16.4567Z",
      fill: color
    }));
  },
  sensorFlow: function sensorFlow(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: color,
      fillOpacity: "0.1"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M27.1109 20.4369L24.0784 17.0961V19.3929H8.15804C7.39993 19.3929 6.78396 18.7143 6.78396 17.8791C6.78396 17.0439 7.39993 16.3653 8.15804 16.3653H19.814C21.8515 16.3653 23.5099 14.5384 23.5099 12.2938C23.5099 10.0492 21.8515 8.22217 19.814 8.22217H7.49469V10.3102H19.814C20.8091 10.3102 21.6146 11.1976 21.6146 12.2938C21.6146 13.39 20.8091 14.2774 19.814 14.2774H8.15804C6.35752 14.2774 4.88867 15.8955 4.88867 17.8791C4.88867 19.8627 6.35752 21.4809 8.15804 21.4809H24.0784V23.7777L27.1109 20.4369Z",
      fill: color
    }));
  },
  sensorLevel: function sensorLevel(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: color,
      fillOpacity: "0.1"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M22.6663 6.69904V4.88867H9.33301V27.1109H22.6663V25.3005H11.3157V22.766H19.4941V20.9557H11.3157V18.4211H18.0071V16.6108H11.3157V14.5741H18.0071V12.7638H11.3157V10.7271H19.4941V8.91673H11.3157V6.69904H22.6663Z",
      fill: color
    }));
  },
  sensorPower: function sensorPower(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: color,
      fillOpacity: "0.1"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M23.7777 12.0334H18.6182L22.0836 4.89209H14.4598L8.22217 18.5103H12.6116L11.6105 27.1463L23.7777 12.0334ZM11.6105 16.2683L15.8459 7.13412H18.7722L15.4609 13.6941L19.6963 13.8602L14.3828 20.3372L15.4609 16.1853H11.6105V16.2683Z",
      fill: color
    }));
  },
  sensorPressure: function sensorPressure(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: color,
      fillOpacity: "0.1"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.6937 19.7035C21.6484 18.633 23.734 15.8071 23.734 12.553C23.7775 8.31406 20.3014 4.88867 15.9998 4.88867C11.6982 4.88867 8.22217 8.31406 8.22217 12.553C8.22217 15.8499 10.3512 18.6759 13.3059 19.7463V21.9728H8.30907V23.6855H15.0439V20.1745C15.348 20.2173 15.6522 20.2173 15.9998 20.2173H15.9998C16.3474 20.2173 16.6516 20.1745 16.9557 20.1317V23.6427H23.734V21.93H18.6937V19.7035ZM9.78639 12.553C9.78639 9.17041 12.5672 6.4301 15.9998 6.4301C19.4324 6.4301 22.2132 9.17041 22.2132 12.553C22.2132 15.9356 19.4324 18.6759 15.9998 18.6759C12.5672 18.6759 9.78639 15.9356 9.78639 12.553ZM23.7778 25.3983H8.30944V27.111H23.7778V25.3983ZM15.9566 7.37212C18.7809 7.37212 21.0838 9.64144 21.0838 12.4246H21.0403V13.0668H10.8294V12.4246C10.8294 9.64144 13.1323 7.37212 15.9566 7.37212ZM16.6518 10.6691V11.7823H19.7368C19.4326 9.98398 17.8684 8.65664 16.0001 8.65664C14.1317 8.65664 12.5675 10.0268 12.2633 11.7823H15.3483V10.6691H16.6518Z",
      fill: color
    }));
  },
  sensorSpeed: function sensorSpeed(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: color,
      fillOpacity: "0.1"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.88867 16.7664C4.88867 10.6798 9.8453 5.77783 15.9998 5.77783C22.1543 5.77783 27.1109 10.6798 27.1109 16.7664C27.1109 18.8497 26.5326 20.8105 25.5413 22.4445L23.1456 21.9952C24.0543 20.7697 24.6739 19.3399 24.8391 17.7468H22.6499V16.1128H24.8804C24.7565 14.438 24.1369 12.9265 23.2282 11.6602L22.0304 12.8448L20.8738 11.701L22.1543 10.4347C20.7086 9.04581 18.7672 8.18796 16.6607 8.02456V10.0262H15.0085V8.02456C13.0258 8.22881 11.291 9.08666 9.92791 10.353L11.2497 11.6602L10.0931 12.804L8.85398 11.5785C7.90396 12.8448 7.28438 14.3971 7.16046 16.072H9.18442V17.7059H7.16046C7.32568 19.2582 7.90396 20.688 8.81267 21.9135L6.45827 22.4037C5.46695 20.7697 4.88867 18.8497 4.88867 16.7664ZM15.5868 20.3204C15.2151 19.9936 15.1325 19.4217 15.5042 18.9723C15.5249 18.9519 15.5558 18.9315 15.5868 18.9111C15.6178 18.8906 15.6488 18.8702 15.6694 18.8498L20.3369 14.5197L16.9912 19.9936C16.9912 20.0344 16.9499 20.1161 16.9086 20.157V20.1978C16.5782 20.6063 15.9586 20.6472 15.5868 20.3204Z",
      fill: color
    }));
  },
  sensorTemperature: function sensorTemperature(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: color,
      fillOpacity: "0.1"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.4443 21.8967C10.4443 24.7521 12.9576 27.1109 15.9999 27.1109C19.0422 27.1109 21.5554 24.8142 21.5554 21.8967C21.5554 20.0346 20.5634 18.3586 18.9099 17.4275V7.61991C18.9099 6.13015 17.5872 4.88867 15.9999 4.88867C14.4126 4.88867 13.0898 6.13015 13.0898 7.61991V17.4275C11.4364 18.3586 10.4443 20.0346 10.4443 21.8967ZM14.3465 7.61991C14.3465 6.75088 15.074 6.06808 15.9999 6.06808C16.9258 6.06808 17.6533 6.75088 17.6533 7.61991V18.1724L17.984 18.3586C19.3729 19.0414 20.2988 20.469 20.2988 21.9588C20.2988 24.1934 18.3808 25.9936 15.9999 25.9936C13.6189 25.9936 11.7009 24.1934 11.7009 21.9588C11.7009 20.469 12.5607 19.0414 14.0158 18.3586L14.3465 18.1724V7.61991ZM16.5951 9.91658V19.1655C17.9178 19.4138 18.976 20.5311 18.9099 21.8967C18.9099 23.4485 17.5871 24.69 15.9337 24.69C14.2803 24.69 12.9575 23.4485 12.9575 21.8967C12.9575 20.5311 14.0157 19.4138 15.3385 19.1655V9.91658H16.5951Z",
      fill: color
    }));
  },
  sensorTime: function sensorTime(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: color,
      fillOpacity: "0.1"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M21.5554 4.88867H10.4443V13.0223L14.7373 15.9756L10.4443 18.9773V27.1109H21.5554V18.9773L17.2625 16.024L21.5554 13.0707V4.88867ZM19.8719 25.1743H12.1278V20.0424L15.9999 17.3312L19.8719 20.0424V25.1743ZM19.8719 11.9088L15.9999 14.62L12.1278 11.9088V6.82525H19.8719V11.9088Z",
      fill: color
    }));
  },
  sensorValve: function sensorValve(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: color,
      fillOpacity: "0.1"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.12496 10.4443H4.88867V21.5554H6.12496V10.4443ZM8.65929 10.4443V21.5554L16.0152 16.6886L23.3711 21.5554V10.4443L16.0152 15.2806L8.65929 10.4443ZM9.9883 19.1067V12.8625L14.7171 15.9846L9.9883 19.1067ZM22.0421 12.8625V19.1067L17.3442 15.9846L22.0421 12.8625ZM25.8746 10.4443H27.1109V21.5554H25.8746V10.4443Z",
      fill: color
    }));
  },
  sensorViscosity: function sensorViscosity(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: color,
      fillOpacity: "0.1"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M15.974 4.88867C15.974 4.88867 7.11084 14.1173 7.11084 18.8005C7.11084 23.4837 10.7695 27.1109 15.974 27.1109C21.1785 27.1109 24.8886 23.3001 24.8886 18.6628C24.8886 14.0255 15.974 4.88867 15.974 4.88867ZM9.17203 18.8005C9.17203 15.1274 15.974 7.59758 15.974 7.59758V25.2743C11.9031 25.2743 9.17203 22.4277 9.17203 18.8005Z",
      fill: color
    }));
  },
  sensorOperatingHours: function sensorOperatingHours(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: color,
      fillOpacity: "0.1"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.4618 26.6668L15.4387 24.5247C10.9988 24.162 7.4979 20.484 7.4979 16.0125C7.4979 11.3015 11.3835 7.4683 16.1596 7.4683C18.8948 7.4683 21.3365 8.72688 22.925 10.6864L20.7176 12.8592H20.9732H26.6668V7.82908V7.00291L24.464 9.1714C22.4765 6.82762 19.4919 5.3335 16.1593 5.3335C10.1901 5.3335 5.3335 10.124 5.3335 16.0125C5.3335 21.6695 9.81667 26.3106 15.4618 26.6668ZM24.3443 15.9071C24.3443 16.8073 24.2017 17.6746 23.9404 18.489L25.9188 19.2281C26.2653 18.1828 26.4556 17.067 26.4556 15.9071H24.3443ZM21.4042 22.312L22.9167 23.7944C23.7624 23.0391 24.4849 22.1495 25.0535 21.16L23.0427 20.4087C22.5928 21.1222 22.0396 21.7634 21.4042 22.312ZM21.1827 25.0525C20.0183 25.7301 18.7145 26.1906 17.3246 26.3799L17.3021 24.2463C18.1142 24.1094 18.8874 23.8571 19.6038 23.5051L21.1827 25.0525ZM21.1751 16.3107V17.1587V18.0067H16.5163H14.8385V16.3107V11.6701H16.5163V16.3107H18.702H21.1751Z",
      fill: color
    }));
  },
  // New Icons - Custom Sensors
  sensorAngle: function sensorAngle(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      fillOpacity: 0.1
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M20.2617 14.8096V16.3096H4.49172C4.29281 16.3096 4.10204 16.2306 3.96139 16.0899C3.82074 15.9492 3.74172 15.7585 3.74172 15.5596C3.74172 15.3607 3.82074 15.1699 3.96139 15.0292C4.10204 14.8886 4.29281 14.8096 4.49172 14.8096H20.2617Z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M8.57031 11.1201C9.24652 11.5468 9.80436 12.1368 10.1924 12.8359C10.5803 13.535 10.786 14.3206 10.7903 15.1201C10.8003 15.2833 10.8003 15.4469 10.7903 15.6101",
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13.4186 13.1399C13.8936 13.1399 14.2786 12.7549 14.2786 12.2799C14.2786 11.805 13.8936 11.4199 13.4186 11.4199C12.9436 11.4199 12.5586 11.805 12.5586 12.2799C12.5586 12.7549 12.9436 13.1399 13.4186 13.1399Z",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M15.625 4.34277L16.6365 5.45046L4.97624 16.0977C4.82936 16.2318 4.6352 16.3021 4.43649 16.2931C4.23779 16.2841 4.0508 16.1965 3.91667 16.0496V16.0496C3.78255 15.9027 3.71226 15.7085 3.72129 15.5098C3.73031 15.3111 3.8179 15.1241 3.96479 14.99L15.625 4.34277Z"
    }));
  },
  sensorConcentration: function sensorConcentration(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      fillOpacity: 0.1
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.2984 6.27977L14.0084 6.26977V11.7498L17.6484 19.2498H6.64844L10.2884 11.7498V6.25977H8.90844",
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.5295 18.1596H8.76953L10.7695 13.3896H13.5295L15.5295 18.1596Z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.0005 2.17986C14.8405 3.97986 12.4805 6.67986 12.4805 8.17986C12.4805 8.90125 12.767 9.59309 13.2771 10.1032C13.7872 10.6133 14.4791 10.8999 15.2005 10.8999C15.9219 10.8999 16.6137 10.6133 17.1238 10.1032C17.6339 9.59309 17.9205 8.90125 17.9205 8.17986C17.9205 6.67986 15.2605 1.99986 15.0005 2.17986ZM16.5505 5.72986L16.9005 6.56986H16.1805L15.8305 5.72986H16.5505ZM17.0005 9.41986H16.2005C16.2005 9.41986 16.4105 9.25986 16.5405 8.50986C16.6047 8.03041 16.5355 7.54252 16.3405 7.09986H17.0005C17.1529 7.55365 17.2207 8.03158 17.2005 8.50986C17.1651 8.81924 17.0981 9.12417 17.0005 9.41986V9.41986Z"
    }));
  },
  sensorDistance: function sensorDistance(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      fillOpacity: 0.1
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.60156 12.8701H18.6416",
      strokeMiterlimit: 10,
      stroke: color
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.82078 14.6096L5.80078 12.8696L7.82078 11.1396",
      strokeMiterlimit: 10,
      stroke: color,
      fill: "none"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.7695 11.1396L18.7795 12.8696L16.7695 14.6096",
      strokeMiterlimit: 10,
      stroke: color,
      fill: "none"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M4.07938 9.50977H3.10938V15.7598H4.07938V9.50977Z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M21.4309 9.50977H20.4609V15.7598H21.4309V9.50977Z"
    }));
  },
  sensorForce: function sensorForce(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      fillOpacity: 0.1
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M15.4414 12.0498H21.4814",
      strokeMiterlimit: 10,
      stroke: color
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.6506 13.7896L14.6406 12.0496L16.6506 10.3096",
      strokeMiterlimit: 10,
      stroke: color,
      fill: "none"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M8.07906 12.0498H2.03906",
      strokeMiterlimit: 10,
      stroke: color
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.85938 10.3096L8.87937 12.0496L6.85938 13.7896",
      strokeMiterlimit: 10,
      stroke: color,
      fill: "none"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.8002 21.3904H8.66016C8.66016 21.3904 10.6602 14.5004 10.6602 12.0004C10.6602 9.50035 8.66016 2.61035 8.66016 2.61035H14.8002C14.8002 2.61035 12.8002 9.29035 12.8002 12.0004C12.8002 14.7104 14.8002 21.3904 14.8002 21.3904Z",
      strokeMiterlimit: 10
    }));
  },
  sensorPosition: function sensorPosition(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      fillOpacity: 0.1
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M22.03 8.16992H21V17.1799H22.03V8.16992Z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M3.02828 8.13965H1.98828V17.1496H3.02828V8.13965Z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      stroke: color,
      fill: "none",
      d: "M4.44922 15.9601L10.7592 12.6401L4.44922 9.33008V15.9601Z",
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      stroke: color,
      fill: "none",
      d: "M12.0003 15.4196C13.6185 15.4196 14.9303 14.1078 14.9303 12.4896C14.9303 10.8714 13.6185 9.55957 12.0003 9.55957C10.3821 9.55957 9.07031 10.8714 9.07031 12.4896C9.07031 14.1078 10.3821 15.4196 12.0003 15.4196Z",
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M11.9991 9.55957C11.2503 9.6033 10.5465 9.93156 10.0318 10.4772C9.51715 11.0228 9.23047 11.7445 9.23047 12.4946C9.23047 13.2446 9.51715 13.9663 10.0318 14.512C10.5465 15.0576 11.2503 15.3858 11.9991 15.4296V9.55957Z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      stroke: color,
      fill: "none",
      d: "M14.9309 13.7697L19.3809 15.7997V9.17969L14.7109 11.3697",
      strokeMiterlimit: 10
    }));
  },
  sensorProgress: function sensorProgress(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      fillOpacity: 0.1
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M4.83062 12.6798C3.89726 12.6798 3.14062 13.4342 3.14062 14.3648C3.14062 15.2954 3.89726 16.0498 4.83062 16.0498H19.6506C20.584 16.0498 21.3406 15.2954 21.3406 14.3648C21.3406 13.4342 20.584 12.6798 19.6506 12.6798H4.83062Z",
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M3.14065 14.3703C3.14065 13.9221 3.31871 13.4922 3.63564 13.1753C3.95258 12.8584 4.38244 12.6803 4.83065 12.6803H12.2707V16.0703H4.83065C4.60788 16.0703 4.3873 16.0263 4.1816 15.9407C3.97591 15.8552 3.78916 15.7298 3.63209 15.5718C3.47503 15.4138 3.35076 15.2263 3.26642 15.0201C3.18208 14.8139 3.13934 14.5931 3.14065 14.3703V14.3703Z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M11.1683 7.14027C11.5438 7.14027 11.8483 6.83583 11.8483 6.46027C11.8483 6.08472 11.5438 5.78027 11.1683 5.78027C10.7927 5.78027 10.4883 6.08472 10.4883 6.46027C10.4883 6.83583 10.7927 7.14027 11.1683 7.14027Z",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13.8284 9.4098C14.204 9.4098 14.5084 9.10536 14.5084 8.7298C14.5084 8.35425 14.204 8.0498 13.8284 8.0498C13.4529 8.0498 13.1484 8.35425 13.1484 8.7298C13.1484 9.10536 13.4529 9.4098 13.8284 9.4098Z",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M14.2016 5.66992L10.8516 9.68992",
      strokeWidth: 0.5,
      strokeMiterlimit: 10,
      strokeLinecap: "round"
    }));
  },
  sensorQuantity: function sensorQuantity(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      fillOpacity: 0.1
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M13.5091 3.38965H10.2891V6.60965H13.5091V3.38965Z",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M11.3997 7.62012H8.17969V10.8401H11.3997V7.62012Z",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M15.6106 7.62012H12.3906V10.8401H15.6106V7.62012Z",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M9.29031 11.8398H6.07031V15.0598H9.29031V11.8398Z",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M13.5091 11.8398H10.2891V15.0598H13.5091V11.8398Z",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M17.7903 11.8398H14.5703V15.0598H17.7903V11.8398Z",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M7.18094 16.1299H3.96094V19.3499H7.18094V16.1299Z",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M11.3997 16.1299H8.17969V19.3499H11.3997V16.1299Z",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M15.6809 16.1299H12.4609V19.3499H15.6809V16.1299Z",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M19.8997 16.1299H16.6797V19.3499H19.8997V16.1299Z",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }));
  },
  sensorTorque: function sensorTorque(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      fillOpacity: 0.1
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.7609 10.8601L16.0009 10.7001C15.934 10.4937 15.8504 10.293 15.7509 10.1001L16.1809 9.44011C16.2223 9.38732 16.2447 9.32218 16.2447 9.25511C16.2447 9.18805 16.2223 9.12291 16.1809 9.07011L14.9809 7.87011C14.9281 7.82875 14.863 7.80628 14.7959 7.80628C14.7288 7.80628 14.6637 7.82875 14.6109 7.87011L13.9509 8.30011C13.7436 8.18089 13.5261 8.08048 13.3009 8.00011L13.1409 7.23011C13.1249 7.16318 13.0863 7.10379 13.0317 7.06192C12.9771 7.02004 12.9097 6.99822 12.8409 7.00011H11.1609C11.0921 6.99822 11.0247 7.02004 10.9701 7.06192C10.9155 7.10379 10.8769 7.16318 10.8609 7.23011L10.7009 8.00011C10.4944 8.06703 10.2938 8.15064 10.1009 8.25011L9.44089 7.82011C9.3881 7.77876 9.32296 7.75628 9.25589 7.75628C9.18883 7.75628 9.12369 7.77876 9.07089 7.82011L7.87089 9.02011C7.82954 9.07291 7.80706 9.13805 7.80706 9.20511C7.80706 9.27218 7.82954 9.33732 7.87089 9.39011L8.30089 10.0501C8.20142 10.243 8.11781 10.4437 8.05089 10.6501L7.28089 10.8101C7.21396 10.8261 7.15458 10.8647 7.1127 10.9193C7.07082 10.974 7.049 11.0413 7.05089 11.1101V12.7901C7.049 12.8589 7.07082 12.9263 7.1127 12.9809C7.15458 13.0355 7.21396 13.0741 7.28089 13.0901L8.00089 13.3001C8.06781 13.5066 8.15142 13.7072 8.25089 13.9001L7.82089 14.5601C7.77954 14.6129 7.75706 14.678 7.75706 14.7451C7.75706 14.8122 7.77954 14.8773 7.82089 14.9301L9.0209 16.1301C9.07369 16.1715 9.13883 16.1939 9.20589 16.1939C9.27296 16.1939 9.3381 16.1715 9.3909 16.1301L10.0509 15.7001C10.2438 15.7996 10.4444 15.8832 10.6509 15.9501L10.8109 16.7201C10.8269 16.787 10.8655 16.8464 10.9201 16.8883C10.9747 16.9302 11.0421 16.952 11.1109 16.9501H12.7909C12.8597 16.952 12.9271 16.9302 12.9817 16.8883C13.0363 16.8464 13.0749 16.787 13.0909 16.7201L13.3009 16.0001C13.5073 15.9332 13.708 15.8496 13.9009 15.7501L14.5609 16.1801C14.6137 16.2215 14.6788 16.2439 14.7459 16.2439C14.813 16.2439 14.8781 16.2215 14.9309 16.1801L16.1309 14.9801C16.1723 14.9273 16.1947 14.8622 16.1947 14.7951C16.1947 14.728 16.1723 14.6629 16.1309 14.6101L15.7009 13.9501C15.8004 13.7572 15.884 13.5566 15.9509 13.3501L16.7209 13.1901C16.7878 13.1741 16.8472 13.1355 16.8891 13.0809C16.931 13.0263 16.9528 12.9589 16.9509 12.8901V11.1601C16.9553 11.0964 16.9392 11.0329 16.9051 10.979C16.8709 10.925 16.8204 10.8834 16.7609 10.8601V10.8601ZM13.7609 12.0001C13.7608 12.3554 13.6551 12.7027 13.457 12.9976C13.259 13.2926 12.9776 13.522 12.6488 13.6565C12.32 13.7911 11.9585 13.8247 11.6105 13.7532C11.2625 13.6817 10.9436 13.5082 10.6945 13.2548C10.4454 13.0015 10.2774 12.6798 10.2117 12.3306C10.1461 11.9814 10.1858 11.6206 10.3259 11.2941C10.466 10.9676 10.7001 10.6901 10.9984 10.4971C11.2967 10.3041 11.6456 10.2042 12.0009 10.2101C12.4756 10.2101 12.9309 10.3987 13.2666 10.7344C13.6023 11.0701 13.7909 11.5254 13.7909 12.0001H13.7609Z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M11.9994 20.39C10.8972 20.3913 9.80563 20.1752 8.78711 19.754C7.76859 19.3329 6.84317 18.7149 6.06382 17.9356C5.28447 17.1562 4.66652 16.2308 4.24535 15.2123C3.82418 14.1938 3.60806 13.1022 3.60938 12",
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M12 3.61036C13.1022 3.60904 14.1938 3.82516 15.2123 4.24633C16.2308 4.6675 17.1562 5.28545 17.9356 6.0648C18.7149 6.84414 19.3329 7.76957 19.754 8.78809C20.1752 9.8066 20.3913 10.8982 20.39 12.0004",
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M10.75 18.6602L12.76 20.3902L10.75 22.1302",
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M13.2717 5.34012L11.2617 3.61012L13.2717 1.87012",
      strokeMiterlimit: 10
    }));
  },
  sensorVibration: function sensorVibration(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      fillOpacity: 0.1
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M7 15L6 13.5043L7 12L6 10.5043L7 9",
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M4 16L3 14.0058L4 12L3 10.0058L4 8",
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M17 9L18 10.4957L17 12L18 13.4957L17 15",
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M20 8L21 9.99424L20 12L21 13.9942L20 16",
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.8844 11.3277L14.4239 11.2312C14.3833 11.1067 14.3326 10.9857 14.2724 10.8694L14.5329 10.4714C14.558 10.4396 14.5716 10.4003 14.5716 10.3598C14.5716 10.3194 14.558 10.2801 14.5329 10.2483L13.8057 9.52468C13.7737 9.49974 13.7343 9.48619 13.6936 9.48619C13.653 9.48619 13.6135 9.49974 13.5815 9.52468L13.1815 9.78397C13.0559 9.71208 12.9241 9.65153 12.7876 9.60307L12.6907 9.13876C12.681 9.0984 12.6576 9.06259 12.6245 9.03734C12.5914 9.01208 12.5506 8.99893 12.5089 9.00007H11.4908C11.4491 8.99893 11.4083 9.01208 11.3752 9.03734C11.3421 9.06259 11.3187 9.0984 11.309 9.13876L11.212 9.60307C11.0869 9.64342 10.9653 9.69384 10.8484 9.75382L10.4484 9.49453C10.4164 9.46959 10.377 9.45604 10.3363 9.45604C10.2957 9.45604 10.2562 9.46959 10.2242 9.49453L9.497 10.2181C9.47193 10.25 9.45831 10.2892 9.45831 10.3297C9.45831 10.3701 9.47193 10.4094 9.497 10.4412L9.75758 10.8392C9.6973 10.9555 9.64663 11.0765 9.60608 11.201L9.13945 11.2975C9.09889 11.3072 9.0629 11.3304 9.03752 11.3634C9.01215 11.3963 8.99892 11.4369 9.00007 11.4784V12.4914C8.99892 12.5329 9.01215 12.5736 9.03752 12.6065C9.0629 12.6394 9.09889 12.6627 9.13945 12.6723L9.57578 12.799C9.61633 12.9235 9.667 13.0445 9.72728 13.1608L9.4667 13.5588C9.44163 13.5906 9.42801 13.6299 9.42801 13.6703C9.42801 13.7108 9.44163 13.75 9.4667 13.7819L10.1939 14.5055C10.2259 14.5304 10.2654 14.544 10.306 14.544C10.3467 14.544 10.3861 14.5304 10.4181 14.5055L10.8181 14.2462C10.935 14.3062 11.0566 14.3566 11.1817 14.3969L11.2787 14.8612C11.2884 14.9016 11.3118 14.9374 11.3449 14.9627C11.378 14.9879 11.4188 15.0011 11.4605 14.9999H12.4786C12.5203 15.0011 12.5611 14.9879 12.5942 14.9627C12.6273 14.9374 12.6507 14.9016 12.6604 14.8612L12.7876 14.4271C12.9127 14.3867 13.0343 14.3363 13.1512 14.2763L13.5512 14.5356C13.5832 14.5606 13.6227 14.5741 13.6633 14.5741C13.704 14.5741 13.7434 14.5606 13.7754 14.5356L14.5026 13.812C14.5277 13.7802 14.5413 13.7409 14.5413 13.7005C14.5413 13.66 14.5277 13.6207 14.5026 13.5889L14.2421 13.1909C14.3023 13.0746 14.353 12.9536 14.3936 12.8291L14.8602 12.7326C14.9007 12.723 14.9367 12.6997 14.9621 12.6668C14.9875 12.6339 15.0007 12.5932 14.9996 12.5517V11.5086C15.0022 11.4701 14.9925 11.4319 14.9718 11.3993C14.9511 11.3668 14.9205 11.3417 14.8844 11.3277V11.3277ZM13.0664 12.0151C13.0664 12.2293 13.0023 12.4387 12.8822 12.6166C12.7622 12.7945 12.5917 12.9328 12.3924 13.0139C12.1932 13.095 11.9741 13.1153 11.7632 13.0722C11.5523 13.0291 11.3591 12.9244 11.2081 12.7717C11.0572 12.6189 10.9553 12.4249 10.9156 12.2143C10.8758 12.0038 10.8999 11.7862 10.9848 11.5893C11.0697 11.3924 11.2115 11.2251 11.3923 11.1088C11.5731 10.9924 11.7845 10.9321 11.9998 10.9357C12.2875 10.9357 12.5634 11.0494 12.7669 11.2518C12.9703 11.4543 13.0846 11.7288 13.0846 12.0151H13.0664Z"
    }));
  },
  sensorVolume: function sensorVolume(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      fillOpacity: 0.1
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.68172 9.9998C7.38172 9.9998 5.51172 9.1198 5.51172 8.0498V16.0498H13.8517V8.0498C13.8517 9.1598 12.0017 9.9998 9.68172 9.9998Z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.70125 18.2596C12.0043 18.2596 13.8713 17.3374 13.8713 16.1996C13.8713 15.0619 12.0043 14.1396 9.70125 14.1396C7.39822 14.1396 5.53125 15.0619 5.53125 16.1996C5.53125 17.3374 7.39822 18.2596 9.70125 18.2596Z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.68078 9.32023C11.6856 9.32023 13.3108 8.51882 13.3108 7.53023C13.3108 6.54165 11.6856 5.74023 9.68078 5.74023C7.67599 5.74023 6.05078 6.54165 6.05078 7.53023C6.05078 8.51882 7.67599 9.32023 9.68078 9.32023Z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M15.3516 5.75V18.25",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M18.4905 6.12012H14.9805",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M18.4905 17.8799H14.9805",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M18.4905 10.1201H14.9805",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M17.4905 8.12012H14.9805",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M17.4905 16.1201H14.9805",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M18.4905 14.1201H14.9805",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M17.4905 12.1201H14.9805",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }));
  },
  sensorWeight: function sensorWeight(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      fillOpacity: 0.1
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      stroke: color,
      d: "M11.9981 8.8898C12.9204 8.8898 13.6681 8.14212 13.6681 7.2198C13.6681 6.29749 12.9204 5.5498 11.9981 5.5498C11.0758 5.5498 10.3281 6.29749 10.3281 7.2198C10.3281 8.14212 11.0758 8.8898 11.9981 8.8898Z",
      strokeMiterlimit: 10
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M17.6219 16.1704L16.1119 9.30035C16.0569 9.04298 15.9181 8.81111 15.7172 8.64102C15.5164 8.47093 15.2648 8.37223 15.0019 8.36035H9.05191C8.78031 8.36114 8.51716 8.45481 8.30615 8.6258C8.09514 8.79679 7.94897 9.03482 7.89191 9.30035L6.37191 16.1704C6.33974 16.3428 6.34578 16.5202 6.38958 16.69C6.43338 16.8599 6.51389 17.0181 6.62543 17.1535C6.73698 17.2888 6.87685 17.3981 7.03519 17.4736C7.19353 17.5491 7.3665 17.5889 7.54191 17.5904H16.4619C16.6376 17.591 16.8113 17.5525 16.9702 17.4775C17.1291 17.4025 17.2693 17.293 17.3804 17.1569C17.4916 17.0208 17.571 16.8616 17.6127 16.6909C17.6545 16.5203 17.6577 16.3424 17.6219 16.1704V16.1704ZM10.8419 15.0004C10.7919 14.8804 10.7319 14.7704 10.6819 14.6604C10.6319 14.5504 10.5819 14.4504 10.5219 14.3404L10.3519 14.0104C10.2919 13.9104 10.2319 13.7904 10.1619 13.6804L10.0419 13.7704L9.92191 13.8404V15.0004H8.79191V11.4004H9.92191V12.6804C10.0068 12.6019 10.087 12.5184 10.1619 12.4304C10.2505 12.3384 10.334 12.2415 10.4119 12.1404L10.6619 11.7904L10.9019 11.4004H12.0019C11.852 11.7093 11.685 12.0098 11.5019 12.3004C11.3578 12.5434 11.1939 12.7742 11.0119 12.9904C11.2019 13.3104 11.3919 13.6404 11.5619 13.9904C11.7319 14.3404 11.9019 14.6904 12.0519 14.9904L10.8419 15.0004ZM13.2219 13.5804C13.2505 13.6887 13.3055 13.7883 13.3819 13.8704C13.4517 13.9498 13.5367 14.0144 13.6319 14.0604C13.7441 14.1011 13.8626 14.1214 13.9819 14.1204H14.1119H14.2219V13.7504H13.7519V12.9004H15.3019V14.8004C15.1087 14.8991 14.9037 14.9731 14.6919 15.0204C14.4498 15.0793 14.201 15.1061 13.9519 15.1004C13.6763 15.1059 13.4019 15.0619 13.1419 14.9704C12.9127 14.8958 12.7039 14.7691 12.5319 14.6004C12.3622 14.4408 12.2291 14.2463 12.1419 14.0304C12.0567 13.7895 12.0127 13.5359 12.0119 13.2804C12.0136 13.0916 12.0371 12.9037 12.0819 12.7204C12.1274 12.5507 12.1982 12.3889 12.2919 12.2404C12.3787 12.0952 12.4865 11.9638 12.6119 11.8504C12.7381 11.7379 12.8795 11.6436 13.0319 11.5704C13.3599 11.415 13.719 11.3363 14.0819 11.3404C14.3043 11.3411 14.5258 11.3679 14.7419 11.4204C14.9433 11.4749 15.1354 11.5592 15.3119 11.6704L15.0519 12.5704L14.8519 12.4504L14.6219 12.3704H14.3719H14.1319C14.0456 12.36 13.9583 12.36 13.8719 12.3704C13.7924 12.3831 13.715 12.4066 13.6419 12.4404C13.5716 12.4778 13.5047 12.5213 13.4419 12.5704L13.2919 12.7504C13.2499 12.8253 13.2196 12.9063 13.2019 12.9904C13.1911 13.0901 13.1911 13.1906 13.2019 13.2904C13.1914 13.4007 13.1982 13.5121 13.2219 13.6204V13.5804Z"
    }));
  },
  sensorHourMeter: function sensorHourMeter(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: color,
      fillOpacity: "0.1"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M19.1119 20.9452L15.1674 17.0008V11.5563H16.8341V16.3063L20.2785 19.7508L19.1119 20.9452ZM16.0008 27.1119C14.4822 27.1119 13.0471 26.8202 11.6952 26.2369C10.3434 25.6535 9.1628 24.8572 8.15354 23.848C7.14428 22.8387 6.34798 21.6582 5.76465 20.3063C5.18132 18.9545 4.88965 17.51 4.88965 15.973C4.88965 14.4545 5.18132 13.0193 5.76465 11.6674C6.34798 10.3156 7.14428 9.13965 8.15354 8.13965C9.1628 7.13965 10.3434 6.34798 11.6952 5.76465C13.0471 5.18132 14.4915 4.88965 16.0285 4.88965C17.5471 4.88965 18.9822 5.18132 20.3341 5.76465C21.6859 6.34798 22.8619 7.13965 23.8619 8.13965C24.8619 9.13965 25.6535 10.3156 26.2369 11.6674C26.8202 13.0193 27.1119 14.4637 27.1119 16.0008C27.1119 17.5193 26.8202 18.9545 26.2369 20.3063C25.6535 21.6582 24.8619 22.8387 23.8619 23.848C22.8619 24.8572 21.6859 25.6535 20.3341 26.2369C18.9822 26.8202 17.5378 27.1119 16.0008 27.1119ZM16.0285 25.4452C18.6396 25.4452 20.8619 24.5239 22.6952 22.6813C24.5285 20.8387 25.4452 18.6026 25.4452 15.973C25.4452 13.3619 24.5285 11.1396 22.6952 9.30631C20.8619 7.47298 18.6304 6.55632 16.0008 6.55632C13.3896 6.55632 11.1628 7.47298 9.3202 9.30631C7.47761 11.1396 6.55632 13.3711 6.55632 16.0008C6.55632 18.6119 7.47761 20.8387 9.3202 22.6813C11.1628 24.5239 13.3989 25.4452 16.0285 25.4452Z",
      fill: color
    }));
  },
  sensorPercentage: function sensorPercentage(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: color,
      fillOpacity: "0.1"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M22.6663 6.69904V4.88867H9.33301V27.1109H22.6663V25.3005H11.3157V22.766H19.4941V20.9557H11.3157V18.4211H18.0071V16.6108H11.3157V14.5741H18.0071V12.7638H11.3157V10.7271H19.4941V8.91673H11.3157V6.69904H22.6663Z",
      fill: color
    }));
  },
  sensorFrequency: function sensorFrequency(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M3 9.5V6.616C3 6.15533 3.15433 5.771 3.463 5.463C3.77167 5.155 4.15567 5.00067 4.615 5H19.385C19.845 5 20.229 5.15433 20.537 5.463C20.845 5.77167 20.9993 6.156 21 6.616V9.5H20V6.616C20 6.462 19.936 6.32067 19.808 6.192C19.68 6.06333 19.539 5.99933 19.385 6H4.615C4.46167 6 4.32067 6.064 4.192 6.192C4.06333 6.32 3.99933 6.46133 4 6.616V9.5H3ZM4.616 19C4.15533 19 3.771 18.846 3.463 18.538C3.155 18.23 3.00067 17.8453 3 17.384V14.5H4V17.385C4 17.5383 4.064 17.6793 4.192 17.808C4.32 17.9367 4.461 18.0007 4.615 18H19.385C19.5383 18 19.6793 17.936 19.808 17.808C19.9367 17.68 20.0007 17.5387 20 17.384V14.5H21V17.385C21 17.845 20.846 18.229 20.538 18.537C20.23 18.845 19.8457 18.9993 19.385 19H4.616ZM10 16.5C10.0933 16.5 10.182 16.4767 10.266 16.43C10.35 16.3833 10.414 16.3133 10.458 16.22L14 9.134L15.542 12.218C15.5867 12.3113 15.6507 12.3813 15.734 12.428C15.8173 12.4747 15.906 12.4987 16 12.5H21V11.5H16.317L14.457 7.78C14.413 7.7 14.3523 7.64167 14.275 7.605C14.1977 7.56833 14.106 7.55 14 7.55C13.9067 7.55 13.8183 7.56833 13.735 7.605C13.6517 7.64167 13.5873 7.70033 13.542 7.781L10 14.866L8.458 11.78C8.41333 11.6867 8.34933 11.6167 8.266 11.57C8.18267 11.5233 8.094 11.5 8 11.5H3V12.5H7.683L9.543 16.22C9.58767 16.3133 9.65167 16.3833 9.735 16.43C9.81833 16.4767 9.90667 16.5 10 16.5Z",
      fill: color
    }));
  },
  errorMachine: function errorMachine() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "8",
      cy: "8",
      r: "8",
      fill: "#F13309"
    }), /*#__PURE__*/_react["default"].createElement("g", {
      clipPath: "url(#clip0_110_78864)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12.4445 4.45041L11.5492 3.55518L8.00001 7.10438L4.45081 3.55518L3.55557 4.45041L7.10477 7.99962L3.55557 11.5488L4.45081 12.4441L8.00001 8.89486L11.5492 12.4441L12.4445 11.5488L8.89525 7.99962L12.4445 4.45041Z",
      fill: "white"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_110_78864"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "10.6667",
      height: "10.6667",
      fill: "white",
      transform: "translate(2.66667 2.6665)"
    }))));
  },
  maintenanceMachine: function maintenanceMachine() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "8",
      cy: "8",
      r: "7",
      fill: "#419BF7",
      fillOpacity: "0.5",
      stroke: "#419BF7",
      strokeWidth: "2"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.33332 4C7.86265 4 6.66665 5.196 6.66665 6.66667C6.66665 6.89689 6.69818 7.12706 6.7604 7.35417L4.72655 9.38802C4.05752 9.5617 3.55554 10.1684 3.55554 10.8889C3.55554 11.7427 4.25725 12.4444 5.1111 12.4444C5.83155 12.4444 6.43829 11.9425 6.61197 11.2734L8.64582 9.23958C8.87293 9.30181 9.1031 9.33333 9.33332 9.33333C10.804 9.33333 12 8.13733 12 6.66667C12 6.34044 11.9365 6.01396 11.8116 5.69618L11.7413 5.51562L10.8507 6.40625C10.6773 6.58003 10.4498 6.66667 10.2222 6.66667C9.99465 6.66667 9.76707 6.58003 9.59374 6.40625C9.24663 6.05914 9.24663 5.49642 9.59374 5.14931L10.4844 4.25868L10.3038 4.18837C9.98603 4.06348 9.65954 4 9.33332 4ZM5.1111 10.2222C5.48455 10.2222 5.77776 10.5154 5.77776 10.8889C5.77776 11.2623 5.48455 11.5556 5.1111 11.5556C4.73764 11.5556 4.44443 11.2623 4.44443 10.8889C4.44443 10.5154 4.73764 10.2222 5.1111 10.2222Z",
      fill: "#419BF7"
    }));
  },
  pauseMachine: function pauseMachine(color) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "8",
      cy: "8",
      r: "7",
      fill: color,
      fillOpacity: "0.5",
      stroke: "#5C35AE",
      strokeWidth: "2"
    }), /*#__PURE__*/_react["default"].createElement("rect", {
      x: "4.66667",
      y: "3.3335",
      width: "2.66667",
      height: "9.33333",
      fill: "#5C35AE"
    }), /*#__PURE__*/_react["default"].createElement("rect", {
      x: "8.66667",
      y: "3.3335",
      width: "2.66667",
      height: "9.33333",
      fill: "#5C35AE"
    }));
  },
  runningMachine: function runningMachine() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "16",
      height: "16",
      rx: "8",
      fill: "#59D66E"
    }), /*#__PURE__*/_react["default"].createElement("g", {
      clipPath: "url(#clip0_110_78896)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.38035 9.70409L4.27309 7.63101L3.55551 8.33198L6.38035 11.111L12.4444 5.14531L11.7319 4.44434L6.38035 9.70409Z",
      fill: "white"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_110_78896"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "10.6667",
      height: "10.6667",
      fill: "white",
      transform: "translate(2.66666 2.6665)"
    }))));
  },
  warningMachine: function warningMachine() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "8",
      cy: "8",
      r: "8",
      fill: "#F19909"
    }), /*#__PURE__*/_react["default"].createElement("g", {
      clipPath: "url(#clip0_110_78861)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.88889 4H7.11111V9.33333H8.88889V4ZM8.88889 11.1111C8.88889 11.602 8.49092 12 8 12C7.50908 12 7.11111 11.602 7.11111 11.1111C7.11111 10.6202 7.50908 10.2222 8 10.2222C8.49092 10.2222 8.88889 10.6202 8.88889 11.1111Z",
      fill: "white"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_110_78861"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "10.6667",
      height: "10.6667",
      fill: "white",
      transform: "translate(2.66666 2.6665)"
    }))));
  },
  preDefIcon: function preDefIcon() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "24",
      height: "24",
      fill: "transparent"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.54 11.0002L13 7.46018L14.41 6.05018L16.53 8.17018L20.77 3.93018L22.18 5.34018L16.54 11.0002ZM11 7.00018H2V9.00018H11V7.00018ZM11 15.0002H2V17.0002H11V15.0002Z",
      fill: "#2BACA4"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13 7.46018L16.54 11.0002L22.18 5.34018L20.77 3.93018L16.53 8.17018L14.41 6.05018L13 7.46018Z",
      fill: "#2BACA4"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13 7.46018L16.54 11.0002L22.18 5.34018L20.77 3.93018L16.53 8.17018L14.41 6.05018L13 7.46018Z",
      fill: "#2BACA4"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13 14.53L16.54 18.07L22.18 12.41L20.77 11L16.53 15.24L14.41 13.12L13 14.53Z",
      fill: "#2BACA4"
    }));
  },
  customIcon: function customIcon() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M17.97 3.8598L15.14 1.0298C14.75 0.639805 14.12 0.639805 13.73 1.0298L9.24 5.5198L5.35 1.6298C4.57 0.849805 3.3 0.849805 2.52 1.6298L0.62 3.5298C-0.16 4.3098 -0.16 5.5798 0.62 6.3598L4.51 10.2498L0 14.7598V18.9998H4.24L8.76 14.4798L12.65 18.3698C13.6 19.3198 14.88 18.9698 15.48 18.3698L17.38 16.4698C18.16 15.6898 18.16 14.4198 17.38 13.6398L13.49 9.7498L17.98 5.2598C18.36 4.8798 18.36 4.2498 17.97 3.8598ZM2.04 4.9398L3.93 3.0398L5.2 4.3098L4.02 5.4998L5.43 6.9098L6.62 5.7198L7.82 6.9198L5.92 8.8198L2.04 4.9398ZM3.41 16.9998H2V15.5898L11.61 5.9798L12.91 7.2798L13.02 7.3898L3.41 16.9998ZM13.5 14.9798L14.69 13.7898L15.96 15.0598L14.06 16.9598L10.17 13.0698L12.07 11.1698L13.27 12.3698L12.08 13.5598L13.5 14.9798ZM14.44 5.9798L13.03 4.5698L14.44 3.1598L15.85 4.5698L14.44 5.9798Z",
      fill: "#2BACA4"
    }));
  }
};